import React, { useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Modal as MuiModal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import { downloadCSV, useRefresh, useListContext } from "react-admin";
import LimitedOfferShare from "../../modules/LimitedOfferTimeShare";
import style from "./Style.module.css";
import dataProvider from "../../../data/dataProvider";
import { ConfirmationPopup } from "./ConfirmationPopup";
import { useGSTStatus } from "../../../utils/hooks";
import { notification_color_keys, useNotifications } from "utils/hooks";
import {
  columnConfig,
  filterConfig,
  tableChipsFormatter,
} from "./limitedOfferTableConfig";
import ExlyTable from "common/Components/ExlyTable";
import { useStyles } from "./limitedOffer.styles";
import { Button, Modal } from "@my-scoot/component-library-legacy";
import {
  MoreActionsButton,
  PrimaryActionField,
  DateField,
  getStatus,
  getCurrencySymbol,
  StatusField,
} from "./components/CustomColumns";
import LearnMoreModal from "../../widgets/LearnMoreModal/LearnMoreModal";
import jsonExport from "jsonexport/dist";
import { orgPermissions, RESOURCE_KEYS } from "../../../utils/OrgPermissions";
import { api } from "data";
import { CreateOfferModal } from "./modals/CreateOfferModal/CreateOfferModal";
import { LTO_EDIT_SESSION_KEY } from "ui/modules/LimitedOfferModalContent/constants";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import {
  LIMITED_TIME_OFFER_LEARN_MORE_HREF,
  moreActionKeys,
} from "./constants";
import LearnMoreCta from "features/Common/modules/LearnMore/modules/LearnMoreCta/LearnMoreCta";
import { EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS } from "features/Common/modules/ExlyEmptyState/constants/ExlyEmptyState.constants";
import { EXLY_TABLE_EMPTY_STATES_VERSIONS } from "common/Components/ExlyTable/ExlyTableEmptyState/constants/ExlyTableEmptyState.constants";
import useFeatureOnboardingChecker from "common/Components/FeatureOnboarding/useFeatureOnboardingChecker";
import { onboardingFeatureKeys } from "common/Components/FeatureOnboarding/FeatureOnboarding.constants";
import { UpgradeModal } from "features/Account/modules/UpgradeModal/UpgradeModal";
import { useCheckLTO } from "ui/modules/Credits/useCheckLTO";
import { LockButton } from "common/Components/LockButton/LockButton";
import Lock from "@material-ui/icons/Lock";
import { LimitedOfferStats } from "./modules/LimitedOfferStats/LimitedOfferStats";
import LimitedOfferMobileCard from "./LimitedOfferMobileCard";
import { SeeMoreModal } from "./seeMoreModal";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";

// TODO: Empty State UI Pending
const FilteredEmptyState = () => {
  return (
    <div className="text-center py-5 text-muted">
      <div>No offers found!</div>
    </div>
  );
};

export const LimitedOffer = withComponentLibraryTheme((props) => {
  const isDesktop = useMediaQuery("(min-width: 767px)");
  const classes = useStyles({ isDesktop });
  const [showModal, setShowModal] = useState(false);
  const [offerModal, setOffermodal] = useState(false);
  const [learnMore, setLearnmore] = useState(false);
  const [dataRecord, setdataRecord] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationTitle, setconfirmationTitle] = useState(false);
  const [moreData, setmoreData] = useState("");
  const [currentSelectedRecord, setCurrentSelectedRecord] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const gst_status = useGSTStatus();
  const HAS_WRITE_ACCESS = orgPermissions.hasFeatureWriteAccess(
    RESOURCE_KEYS.SECTIONS.LIMITED_TIME_OFFER
  );
  const refresh = useRefresh();
  const { notify } = useNotifications();

  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showOfferDetailsModal, setShowOfferDetailsModal] = useState(false);

  const handleSeeMore = (record) => {
    setSelectedOffer(record);
    setShowOfferDetailsModal(true);
  };
  const [mobileActionsOpen, setMobileActionsOpen] = useState(false);

  const { totalCredits, canCreateLTO } = useCheckLTO();

  const {
    isOnboardedPrevVal: isFeatureVisited,
    flagLoading: isFeatureFlagLoading,
    handleFeatureOnboardChange,
  } = useFeatureOnboardingChecker({
    featureKey: onboardingFeatureKeys.KNOWLEDGE_BASE.LTO,
    successCallback: (marked) => !marked && handleFeatureOnboardChange(true),
  });

  const options = [
    {
      key: 0,
      data: HAS_WRITE_ACCESS
        ? [
            moreActionKeys.edit,
            moreActionKeys.share,
            moreActionKeys.delete,
            moreActionKeys.viewTransactions,
          ]
        : [moreActionKeys.share, moreActionKeys.viewTransactions],
    },
    {
      key: 1,
      data: HAS_WRITE_ACCESS
        ? [
            moreActionKeys.edit,
            moreActionKeys.share,
            moreActionKeys.endOffer,
            moreActionKeys.viewTransactions,
          ]
        : [moreActionKeys.share, moreActionKeys.viewTransactions],
    },
    {
      key: 2,
      data: [moreActionKeys.viewTransactions],
    },
  ];

  const handleClick = () => {
    if (!canCreateLTO) {
      setShowUpgradeModal(true);
      return;
    }
    setShowModal(!showModal);
    setOffermodal(!offerModal);
    if (window.sessionStorage.getItem(LTO_EDIT_SESSION_KEY)) {
      window.sessionStorage.removeItem(LTO_EDIT_SESSION_KEY);
    }
  };

  const handleDelete = async () => {
    try {
      const record = dataRecord;
      const payload = {
        offer_uid: record.uuid,
      };
      const deleteData = await dataProvider.custom_request(
        "host/offer/delete",
        "POST",
        payload
      );
      if (deleteData.status === 200) {
        notify("Deleted successfully!", notification_color_keys.success);
      }
      setConfirmationModal(false);
      refresh();
    } catch (err) {
      notify(err?.body?.message, notification_color_keys.error);
    }
  };

  const handleEndOffer = async () => {
    setConfirmationModal(false);
    notify("Expiring offer...", notification_color_keys.info);
    try {
      const record = dataRecord;
      const payload = {
        offer_uid: record.uuid,
      };
      const expireOffer = await dataProvider.custom_request(
        "host/offer/expire",
        "POST",
        payload
      );
      if (expireOffer.status === 200) {
        notify("Offer expired successfully!", notification_color_keys.success);
      }
      refresh();
    } catch (err) {
      notify(err?.body?.message, notification_color_keys.error);
    }
  };

  const handleItemClick = async (itemData, record) => {
    if (itemData === "Share") {
      setIsModal(true);
    } else if (itemData === "Edit") {
      handleClick();
      window.sessionStorage.setItem(
        LTO_EDIT_SESSION_KEY,
        JSON.stringify(record)
      );
    } else if (itemData === "Delete") {
      setConfirmationModal(true);
      setconfirmationTitle(
        "Are you sure you want to delete this active discount? Doing so will change the price to the original price."
      );
    } else if (itemData === "End Offer") {
      setConfirmationModal(true);
      setconfirmationTitle(
        "Are you sure?, Once you end the offer, your customers will not be able to avail the discount."
      );
    } else if (itemData === "View Transactions") {
      window.location.href = `${window.location.origin}/#/${api.transaction_list}?feature_discount_info__early_bird_id=${record.uuid}`;
    }
  };

  const ltoOfferUuid =
    dataRecord?.listing_uuid ||
    (dataRecord?.dynamic_link_uuids?.[0]
      ? typeof dataRecord.dynamic_link_uuids[0] === "string"
        ? dataRecord.dynamic_link_uuids[0]
        : dataRecord.dynamic_link_uuids[0].dynamic_link_id
      : null) ||
    dataRecord?.combo_pages?.[0]?.dynamic_link_id;

  const secondaryComponent = (
    <div className={classes.buttonsContainer}>
      {HAS_WRITE_ACCESS && (
        <div className="d-flex">
          <LearnMoreCta
            href={LIMITED_TIME_OFFER_LEARN_MORE_HREF.LTO}
            className="mr-3"
          />
          {canCreateLTO ? (
            <Button
              className={classes.buttonClassName}
              color="primary"
              onClick={handleClick}
            >
              Create Limited-Time Offer
            </Button>
          ) : (
            <LockButton
              text="Create Limited-Time Offer"
              onClick={handleClick}
            />
          )}
        </div>
      )}
    </div>
  );

  const exporter = (data) => {
    dataProvider.postAnalyticalEvent("limitedOffer", "export", {
      flow: "limitedOffer",
      funnel: "limitedOffer",
      ui_component: "Text Button",
      identifier: "EXPORT",
    });
    const dataForExport = data.map((data) => {
      let return_data = {
        "Offer Name": data.title,
        "Offering Name": data.listing_name,
        "Discount value": `${getCurrencySymbol(data)} ${data.price}`,
        "Total discount given":
          (data.total_discount &&
            `${getCurrencySymbol(data)} ${data.total_discount}`) ||
          `N/A`,
        "No. of bookings": data.bookings || `N/A`,
        "Discount end date": DateField({
          record: data,
          source: "end_datetime",
        }),
        Status: getStatus(data),
      };
      return return_data;
    });
    jsonExport(
      dataForExport,
      {
        headers: [
          "Offer Name",
          "Offering Name",
          "Discount value",
          "Total discount given",
          "No. of bookings",
          // "Discount end date",
          // "Status",
        ], // order fields in the export
      },
      (err, csv) => {
        downloadCSV(csv, "Limited Offer"); // download as 'posts.csv` file
      }
    );
  };

  const footerProps = canCreateLTO
    ? {
        primarybtn: "Create Limited-Time Offer",
        primaryClick: () => handleClick(),
        hidePrimarybtn: !HAS_WRITE_ACCESS,
      }
    : {
        primarybtn: (
          <>
            <Lock className="tw-text-black tw-mr-2" fontSize="small" />
            <div>Create Limited-Time Offer</div>
          </>
        ),
        primaryClick: () => handleClick(),
        hidePrimarybtn: !HAS_WRITE_ACCESS,
        primaryBtnProps: {
          className:
            "!tw-text-black !tw-bg-[linear-gradient(124.63deg,#FFD37E_3.13%,#F7AD1E_106.11%)] !tw-p-4 !tw-border-none",
        },
      };

  const getMoreActions = (record) => {
    if (!record) return;

    const isSingleTarget = record?.is_single_target !== false;

    const option = options.find((option) => option.key === record?.status);
    return option.data
      .filter((action) => action !== moreActionKeys.share || isSingleTarget)
      .map((action) => ({
        label:
          action === "View Transactions" && record.bookings
            ? action
            : action !== "View Transactions"
            ? action
            : null,
        onClick: () => {
          setdataRecord(record);
          handleItemClick(action, record);
          setmoreData(action);
        },
      }))
      .filter((option) => option.label);
  };

  const ltoColumns = columnConfig(classes);

  const LimitedOfferMobileTable = () => {
    const { data } = useListContext();

    const rows = Object.values(data || {});

    return (
      <div className="tw-flex tw-flex-col tw-gap-3">
        {rows.map((record, index) => (
          <LimitedOfferMobileCard
            key={record.id}
            record={record}
            columns={ltoColumns}
            isAlternate={index % 2 !== 0}
            onSeeMore={() => handleSeeMore(record)}
            onMoreActions={() => {
              setCurrentSelectedRecord(record);
              setMobileActionsOpen(true);
            }}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="component-wrapper">
      <UpgradeModal
        isOpen={showUpgradeModal}
        message={`Your plan supports only ${totalCredits} countdown timer`}
        description="Create more limited-time offer, like you're letting your customers in on a secret deal that won't last forever."
        setShowUpgradeModal={setShowUpgradeModal}
      />
      <ExlyTable
        useCustomMobileTable
        MobileComponent={LimitedOfferMobileTable}
        tableTitle="Limited-Time Offers"
        ra_props={{
          ...props,
          exporter: orgPermissions.canExport() ? exporter : false,
        }}
        noExportButton={!orgPermissions.canExport()}
        columnConfig={ltoColumns}
        tableFilters={filterConfig}
        statsComponent={LimitedOfferStats}
        layoutProps={{
          secondaryComponent: isDesktop ? secondaryComponent : null,
          paddingDesktop: "0",
          paddingMobile: "0",
          paddingBottom: "120px",
          noMobileBoxShadow: true,
          learnMoreHref: LIMITED_TIME_OFFER_LEARN_MORE_HREF.LTO,
        }}
        filteredEmptyState={<FilteredEmptyState />}
        tableChipsFormatter={tableChipsFormatter}
        primaryKey="id"
        borderedFields
        fieldsLeftPadded
        fieldsAlignment="space-between"
        drawerFieldsBordered
        drawerFieldsAlignment="space-between"
        recordFooterVariant="secondary"
        footerProps={footerProps}
        hasMobileFooter={HAS_WRITE_ACCESS}
        renderSecondaryAction={(record) => <StatusField record={record} />}
        customPrimaryAction={{
          renderCustomAction: (
            record,
            rows,
            setDrawerConfig,
            setActionsDrawerConfig
          ) =>
            record.status !== 2 && (
              <MoreActionsButton
                label="More Actions"
                onClick={() => {
                  setCurrentSelectedRecord(record);
                  setActionsDrawerConfig({ row: record, open: true });
                }}
              />
            ),
          onClose: (row, rows, setDrawerConfig, setActionsDrawerConfig) => {
            setActionsDrawerConfig((prevState) => ({
              ...prevState,
              open: false,
            }));
          },
        }}
        recordFooterClassName={classes.recordFooterClassName}
        primaryActions={getMoreActions(currentSelectedRecord)}
        desktopCustomPrimaryAction={{
          renderCustomAction: (row, rows, setAnchorEl, setOpenPopper) =>
            row.status !== 2 && (
              <PrimaryActionField
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setOpenPopper(true);
                  setCurrentSelectedRecord(row);
                }}
              />
            ),
        }}
        primaryColumnProps={{
          sticky: true,
          fixed: "right",
          width: "80px",
          align: "center",
          title: "Actions",
          className: "!tw-text-center",
        }}
        emptyStateProps={{
          isLoading: isFeatureFlagLoading,
          version: EXLY_TABLE_EMPTY_STATES_VERSIONS.V2,
          title: "No limited time offer yet",
          description:
            "As soon as we have a new limited time offer, it will show up here. View the video to learn more.",
          videoSrc: LIMITED_TIME_OFFER_LEARN_MORE_HREF.LTO_VIDEO,
          playerProps: {
            playing: !isFeatureFlagLoading && !isFeatureVisited, // autoplay the knowledge base video on the first visit to this feature
          },
          primaryCtaProps: HAS_WRITE_ACCESS && {
            title: "Create Limited-Time Offer",
            onClick: handleClick,
          },
          secondaryCtaProps: {
            variant: EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS.learn_more,
            learnMoreHref: LIMITED_TIME_OFFER_LEARN_MORE_HREF.LTO,
          },
          className: "mt-3",
        }}
      />

      {showModal && (
        <CreateOfferModal
          open={showModal}
          onClose={handleClick}
          gst_status={gst_status}
        />
      )}
      <LearnMoreModal
        title="How To Use Limited-Time Offers"
        list={[
          "Create discounts for your classes/workshops/content",
          "Set a limited time for which the offer will be valid",
          "Offer to be availed by all customers or students",
        ]}
        open={learnMore}
        icon={require("../../../assets/images/Create_limited_time_offers.svg")}
        onModalClose={() => setLearnmore(false)}
        onClose={() => {
          setLearnmore(false);
          setShowModal(false);
        }}
      />

      <Modal
        open={isModal}
        onClose={() => {
          setIsModal(false);
        }}
        customHeader={<></>}
        customFooter={<></>}
      >
        <LimitedOfferShare
          setShowModal={isModal}
          uid={ltoOfferUuid}
          listing={dataRecord}
        />
      </Modal>

      <ExlyModal
        open={mobileActionsOpen}
        onClose={() => setMobileActionsOpen(false)}
        title=""
        customHeader={<></>}
        customFooter={<></>}
        backDropClickClose
      >
        {getMoreActions(currentSelectedRecord)?.map((action) => (
          <div
            key={action.label}
            className="tw-py-2 tw-border-b tw-cursor-pointer"
            onClick={() => {
              action.onClick();
              setMobileActionsOpen(false);
            }}
          >
            {action.label}
          </div>
        ))}
      </ExlyModal>

      <ExlyModal
        open={showOfferDetailsModal}
        onClose={() => setShowOfferDetailsModal(false)}
        title="All details"
        customFooter={<></>}
      >
        {selectedOffer && (
          <SeeMoreModal record={selectedOffer} columns={ltoColumns} />
        )}
      </ExlyModal>

      <MuiModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={confirmationModal}
        onClose={() => {
          setConfirmationModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={`alert_modal ${style.confirmationalert}`}>
          <ConfirmationPopup
            handleEndOffer={handleEndOffer}
            title={confirmationTitle}
            action={moreData}
            handleDelete={handleDelete}
            setConfirmationModal={setConfirmationModal}
          />
        </div>
      </MuiModal>
    </div>
  );
});
